import { Sliders } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import YourFeedYourRulesImg from '../../../assets/welcoming-slide-2-process.png';
import { Img } from '@chakra-ui/react';

export default function Slide2() {
  const [animate, setAnimate] = useState(false);

  const scores = [
    { name: 'Clickbait', value: 30, color: 'bg-[#BFDDBF]', textColor: 'black' },
    { name: 'Trustworthiness', value: 45, color: 'bg-[#A1D199]', textColor: 'black' },
    { name: 'Educational Value', value: 90, color: 'bg-growth-green', textColor: 'white' },
    { name: 'Perspective Diversity', value: 70, color: 'bg-green-800', textColor: 'white' }
  ];

  useEffect(() => {
    // Trigger animation when slide becomes active
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 300); // Small delay to let slide transition complete

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="animate-in slide-in-from-right duration-300 max-w-4xl mx-auto px-4 md:px-0">
      <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 mb-6 md:mb-10 text-center">
        Your feed, your rules
      </h1>

      {/* Single column layout with two rows */}
      <div className="space-y-8 md:space-y-12 lg:space-y-20">
        {/* First row: Text left, Scores right */}
        <div className="grid grid-cols-1 md:grid-cols-[30%_auto] gap-6 md:gap-10 lg:gap-14 items-center md:ml-7">
          {/* Left side: Text content */}
          <div>
            <p className="text-gray-700 text-base md:text-lg lg:text-xl font-bold text-center md:text-left">
              Content is scored on quality factors you can actually control.
            </p>
          </div>

          {/* Right side: Scores */}
          <div className="space-y-3 md:space-y-4">
            {scores.map((score, index) => (
              <div key={score.name} className="relative">
                {/* Gray placeholder background (100%) */}
                <div className="bg-gray-200 rounded-full h-5 md:h-6 w-full absolute"></div>
                {/* Colored score bar */}
                <div
                  className={`${score.color} rounded-full h-5 md:h-6 transition-all duration-1000 flex items-center px-3 md:px-4 relative`}
                  style={{
                    width: animate ? `${score.value}%` : '0%',
                    transitionDelay: animate ? `${index * 0.1}s` : '0s'
                  }}
                >
                  <span
                    className={`text-${score.textColor} text-xs md:text-sm font-extrabold whitespace-nowrap`}
                  >
                    {score.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Second row: Customization with full background */}
        <div
          className="rounded-xl h-auto md:h-[155px] flex items-center overflow-visible py-6 md:py-0 mr-0 md:mr-7"
          style={{
            background: 'linear-gradient(128.97deg, #F9F6FE 27.64%, #F4FDF6 99.68%)',
            border: '1px solid #F3E8FF'
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-center px-4 md:px-6 w-full">
            {/* Left side: Text content */}
            <div className="md:scale-[0.8] md:origin-left">
              <h3 className="font-bold text-gray-900 mb-3 md:mb-4 flex items-center text-sm md:text-base">
                <Sliders className="w-4 h-4 md:w-5 md:h-5 mr-2 text-green-600 rotate-[270deg]" />
                Customize Your Experience
              </h3>
              <div className="ml-6 md:ml-7 space-y-1">
                <p className="text-gray-700 text-sm md:text-base lg:text-lg">Tired of clickbait?</p>
                <p className="text-gray-700 text-sm md:text-base lg:text-lg">Want more humor?</p>
                <p className="text-gray-700 text-sm md:text-base lg:text-lg">
                  Want serious analysis?
                </p>
                <p className="text-gray-700 text-sm md:text-base lg:text-lg">
                  Want another perspective?
                </p>
              </div>
            </div>

            {/* Right side: Radar chart illustration */}
            <div className="relative h-full overflow-visible flex items-center justify-center md:justify-end mt-4 md:mt-0 -mb-12 md:mb-0">
              <Img
                src={YourFeedYourRulesImg}
                alt="Customization visualization"
                className="h-auto w-full scale-[120%] origin-bottom md:scale-[105%] max-w-[250px] md:max-w-[300px] lg:w-[343px]"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 md:mt-12 lg:mt-14 text-center px-2">
        <p className="text-growth-green font-semibold text-sm md:text-base lg:text-lg">
          You decide what matters. Not an algorithm designed to keep you scrolling.
        </p>
      </div>
    </div>
  );
}
